export default __webpack_public_path__ + "static/media/calendar.85e31447.svg";